var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["order", { authorized: _vm.isAuthorized }] }, [
    _c(
      "a",
      {
        staticClass: "order__title",
        attrs: { href: "/orders/" + _vm.orderTitle + "/" },
      },
      [_vm._v("\n    Заказ № " + _vm._s(_vm.orderTitle) + "\n  ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "order__info" }, [
      _c("span", { staticClass: "order__date" }, [
        _vm._v("\n      Дата доставки: " + _vm._s(_vm.orderDate) + "\n    "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "order__status" }, [
        _vm._v("\n      Статус: " + _vm._s(_vm.orderStatus) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    !_vm.isAuthorized
      ? _c(
          "button",
          {
            staticClass: "_btn _btn--transparent order__button",
            on: { click: _vm.clickHandler },
          },
          [
            _c("span"),
            _vm._v(" "),
            _c("p", [_vm._v("Отправить статус на почту")]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.sendStatus && _vm.sendStatus.isShow
      ? _c("p", {
          class: [
            "send-message__status",
            _vm.sendStatus.isSuccess ? "_success" : "_error",
          ],
          domProps: { innerHTML: _vm._s(_vm.sendStatus.text) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }